import React, { Children, useEffect, useState } from 'react';
import './CustomSelect.css';
import { svgIcons } from '../../../style/fonts/SvgIcons';

interface Option {
  value: string;
  label: string;
 
}

interface CustomSelectProps {
  options: Option[];
  children?:React.ReactNode;
  onClick?: () => void;
}

const CustomSelect: React.FC<CustomSelectProps> = ({ options,children }) => {
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);

  const handleDeleteOption = (optionValue: string) => {
    // Handle delete action (e.g., remove option from options array)
    console.log(`Deleted option with value: ${optionValue}`);
  };
  useEffect(() => {
    if (options.length > 0) {
      setSelectedOption(options[0]);
    }
  }, [options]);

  const handleOptionClick = (option: Option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  return (
    <div className="custom-select-container ">
      <div className="custom-select-header dropdown-toggle" onClick={() => setIsOpen(!isOpen)}>
        {selectedOption ? selectedOption.label : 'select'}
      </div>
      {isOpen && (
        <>
        <div className="custom-select-options ">
          {options.map((option) => (
            <>
            <div className='d-flex justify-content-between'>

           
            <div
              key={option.value}
              className={`custom-select-option w-100 ${option.value}`}
              onClick={() => handleOptionClick(option)}
            >
              <div className='gap-2 d-flex align-items-center justify-content-between'>
                <div>
              {selectedOption && selectedOption.value === option.value ? (
                <i className='fa fa-check'></i>
              ) : (
                <i className='me-3'></i>
              )}
              {option.label}
              </div>
              <div>
              {isDeleteMode && (
                  <i className='fa fa-trash' onClick={() => handleDeleteOption(option.value)} ></i>
                )}
              </div>
              
              </div>
            </div>
            </div>
           </>
          ))}
          {children && React.cloneElement(children as React.ReactElement, { onClick: () => setIsDeleteMode(!isDeleteMode) })}
        </div>
        
       </>
      )}
      
    </div>

  );
};

export default CustomSelect;
